<template>
  <div class="addmodal fixed w-full h-screen z-20 top-0 left-0 flex justify-center items-start overflow-auto">
    <div class="bg-white m-auto w-9/12 md:w-7/12 h-auto flex flex-col rounded-md justify-center items-center">
      <h2
        class="font-costea w-11/12 px-2 py-1 my-4 mx-auto border-b border-gray-200 text-left text-t20 font-medium text-costeaBlack">
        Editar componente
      </h2>
      <div class="bg-gray-200 w-11/12 h-24 rounded-md relative mb-4"
        :style="`background-repeat: no-repeat; background-size: contain; background-position:center center; ${showImage}`">
        <span @click="$refs.myFiles.click()"
          class="cursor-pointer flex flex-row items-center justify-center absolute bg-costeaPrimary text-white w-10 h-10 right-4 bottom-4 rounded-full">
          <i class="ri-camera-fill text-lg"></i>
          <input type="file" @input="pickFile" @change="onSelectedImage" ref="myFiles" style="display:none" />
        </span>
      </div>

      <p v-if="errorSizeImage"
        class="text-costeaSalmon font-costea text-t12 text-left w-11/12 bg-costeaSalmonDisabled px-2 py-1 rounded-md ">
        {{ this.errorSizeImage }}</p>

      <form @submit.prevent="editComponent" class="flex flex-col justify-start items-center w-11/12">

        <div class="flex items-center justify-between w-full flex-col sm:flex-row flex-wrap">
          <div class="mb-4 px-2 py-2 flex flex-col content-center items-center w-10/12 sm:w-6/12 rounded-md">
            <p for="nombre" class="w-full text-costeaGray items-center content-center text-t16 mb-3">Nombre: *</p>
            <input id="nombre" type="text" :value="componentOld" @input="changeName" required
              class="bg-white placeholder-gray-300 border-gray-400 border outline-none font-costea px-2 p-3 text-t16 w-full rounded-md tracking-wide"
              placeholder="Nombre del componente">
          </div>
          <div class="mb-4 px-2 py-2 flex flex-col content-center items-center w-10/12 sm:w-6/12 rounded-md">
            <p for="referencia" class="w-full text-costeaGray items-center content-center text-t16 mb-3">Referencia: *
            </p>
            <input id="referencia" type="text" :value="referencia" @input="changeReferencia" required
              class="bg-white placeholder-gray-300 border-gray-400 border outline-none font-costea px-2 p-3 text-t16 w-full rounded-md tracking-wide"
              placeholder="Referencia del componente">
          </div>
        </div>

        <div class="flex items-center justify-between w-full flex-col sm:flex-row flex-wrap">
          <div class="mb-4 px-2 py-2 flex flex-col content-center items-center w-10/12 sm:w-6/12 rounded-md">
            <p for="codigoBarras" class="w-full text-costeaGray items-center content-center text-t16 mb-3">Código de
              barras: *</p>
            <input id="codigoBarras" type="text" :value="codigoBarras" @input="changeCodigoBarras"
              class="bg-white placeholder-gray-300 border-gray-400 border outline-none font-costea px-2 p-3 text-t16 w-full rounded-md tracking-wide"
              placeholder="Código de barras">
          </div>
          <div class="mb-4 px-2 py-2 flex flex-col content-center items-center w-10/12 sm:w-6/12 rounded-md">
            <p for="unidadMedida" class="w-full text-costeaGray items-center content-center text-t16 mb-3">Unidad de
              medida: *</p>
            <select id="unidadMedida" :value="unidadMedida" @input="changeUnidadMedida" required
              class="bg-white placeholder-gray-300 border-gray-400 border outline-none font-costea px-2 p-3 text-t16 w-full rounded-md tracking-wide">
              <option value="" selected disabled>Seleccione una unidad (kg,cm,lb...)</option>
              <option value="kg">Kilogramos kg</option>
              <option value="cm">Centímetros cm</option>
              <option value="m">Metros m</option>
              <option value="u">Unidad u</option>
              <option value="L">Litros</option>
              <option value="ml">Mililitros</option>
              <option value="cm3">Centímetros cm3</option>
              <option value="gr">Gramos</option>
              <option value="lb">Libras</option>
              <option value="km">Kilometro</option>
              <option value="t">Toneladas</option>
            </select>
          </div>
        </div>

        <div class="flex items-center justify-between w-full flex-col sm:flex-row flex-wrap">
          <div class="mb-4 px-2 py-2 flex flex-col content-center items-center w-10/12 sm:w-6/12 rounded-md">
            <p class="w-full text-t14 mb-2">Materia prima actual: <span
                class="uppercase bg-gray-100 tracking-wider text-costeaGray italic p-1 rounded-md text-t14 font-bold">{{ materiaPrima }}</span>
            </p>
            <p class="w-full text-costeaGray items-center content-center text-t16 mb-3">Cambiar tipo de materia prima *
            </p>
            <div class="flex justify-start items-center w-10/12">
              <input type="radio" id="mpNacional" value="Nacional" v-model="dataMateriaPrima"
                class="h-3 justify-start items-center outline-none" @click="cop = true, usd = false">
              <label for="mpNacional"
                class="relative text-costeaBlack text-t14 tracking-wide mr-2 leading-6 cursor-pointer">Nacional</label>
              <input type="radio" id="mpImportada" value="Importada" v-model="dataMateriaPrima"
                class="h-3 justify-start items-center outline-none" @click="cop = false, usd = true">
              <label for="mpImportada"
                class="relative text-costeaBlack text-t14 tracking-wide ml-2 leading-6 cursor-pointer">Importada</label>
            </div>
          </div>

          <div class="mb-4 px-2 py-2 flex flex-col content-center items-center w-10/12 sm:w-6/12 rounded-md">
            <div v-if="this.dataMateriaPrima === 'Nacional'" class="w-full">
              <p class="w-full text-costeaGray items-center content-center text-t16 mb-3">Costo en COP *</p>
              <input id="costoCOP" type="number" step="0.01" min="0" max="999999"  v-model="costoUnitarioInput"
                @input="changeCostoUnitario" required
                class=" bg-white placeholder-gray-300 border-gray-400 border outline-none font-costea px-2 p-3 text-t16 w-full rounded-md tracking-wide"
                placeholder="$ --">
            </div>
            <div v-if="this.dataMateriaPrima === 'Importada'" class="flex w-full flex-row justify-end items-center flex-wrap">
              <div class="lg:w-5/12 w-full flex flex-col">
                <p class="text-costeaGray items-center content-center text-t14 mb-2">Costo en USD *</p>
                <input id="costoUnitarioUsd" type="number" min="0" max="999999" step="0.01"  v-model="costoUnitarioInput"
                  @input="changeCostoUnitario" required
                  class=" bg-white placeholder-gray-300 border-gray-400 border outline-none font-costea p-2 text-t14 w-full rounded-md tracking-wide"
                  placeholder="$ --">
              </div>
              <div class="lg:w-5/12 w-full flex flex-col">
                <p class="text-costeaGray items-center content-center text-t14 mb-2">Tasa de cambio *</p>
                <input id="tasaCambio" type="number" min="0" max="999999" step="0.0001" :value="tasaCambio"
                  @input="changeTasaCambio" required
                  class=" bg-white placeholder-gray-300 border-gray-400 border outline-none font-costea p-2 text-t14 w-full rounded-md tracking-wide"
                  placeholder="$ --">
              </div>
              <div class="w-full flex justify-end flex-row mt-4 items-center">
                <p class="text-right text-costeaGray items-center content-center text-t16 mb-3">COP <span
                    class="text-black text-t18 font-bold">$ {{ interNumberFormat((tasaCambio *
                        costoUnitario).toFixed(2))
                    }}</span></p>
              </div>
            </div>

          </div>
        </div>
        <div class="mb-4 p-2 flex content-end items-end w-full rounded-md justify-end">
          <button
            class="bg-costeaBtn2 rounded-md text-costeaPrimary hover:bg-costeaBtn2Hover duration-100 ease-in px-2 py-3 cursor-pointer w-36 box-border text-t12 uppercase tracking-wide mr-4"
            @click="toggleModal()" type="button">Cancelar</button>
          <button @click="onProcess()"
            :class="'rounded-md text-white hover:bg-costeaHover duration-100 ease-in px-2 py-3 cursor-pointer w-36 box-border text-t12 uppercase tracking-wide ml-4 ' + buttonBg"
            type="submit">{{ buttonText }}</button>
        </div>
      </form>

    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
export default {
  data() {
    return {
      cop: false,
      usd: false,
      buttonText: 'Actualizar',
      buttonBg: 'bg-costeaPrimary',
      modalAct: true,

      dataComponentOld: '',
      dataComponentId: '',
      dataReferencia: '',
      dataCodigoBarras: '',
      dataUnidadMedida: '',
      dataCostoUnitario: '',
      dataTasaCambio: '',
      dataMateriaPrima: this.materiaPrima,


      costoUnitarioInput: this.costoUnitario,

      calcTasaCambio: '',


      picture: null,
      previewImage: null,

      errorSizeImage: '',
    }
  },
  mounted() {
    this.test

  },
  computed: {
    ...mapState(['costea']),
    getCosto() {
      if (this.modalAct == true) {
        this.tipoCosto()
      }
      return console.log('Ejecutado con exito')
    },
    showImage() {
      if (this.previewImage != null) {
        return `background-image:url('${this.previewImage}');`
      } else {
        return 'background-color: #f1f2f3;'
      }
    },

  },
  props: ['componentOld', 'componentId', 'referencia', 'codigoBarras', 'unidadMedida', 'costoUnitario', 'tasaCambio', 'materiaPrima'],
  methods: {
    interNumberFormat(number) {
      let interNF = new Intl.NumberFormat('es-CO');
      let numberDecimals = parseFloat(number)
      numberDecimals = numberDecimals.toFixed(2)
      return interNF.format(numberDecimals)
    },
    changeName(event) {
      this.dataComponentOld = event.target.value;
    },
    changeReferencia(event) {
      this.dataReferencia = event.target.value
    },
    changeCodigoBarras(event) {
      this.dataCodigoBarras = event.target.value
    },
    changeUnidadMedida(event) {
      this.dataUnidadMedida = event.target.value
    },
    changeCostoUnitario() {
      this.dataCostoUnitario = this.costoUnitarioInput
      this.calcCostoUnitario = this.costoUnitarioInput
      // this.dataCostoUnitario = event.target.value
      // this.calcCostoUnitario = event.target.value
    },
    changeTasaCambio(event) {
      this.dataTasaCambio = event.target.value
      this.calcTasaCambio = event.target.value
    },
    changeMateriaPrima(event) {
      this.dataMateriaPrima = event.target.value
    },

    editComponent: function () {
      this.errorSizeImage = ''
      if (this.picture && this.picture.size > 450000) {
        this.errorSizeImage = 'El tamaño de la imagen no puede ser mayor a 450kb'
        this.buttonText = 'Actualizar'
        return
      }

      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      let formData = new FormData()
      if (this.picture != null) {
        formData.append('picture', this.picture);
      }
      formData.append('name', this.dataComponentOld != "" ? this.dataComponentOld : this.componentOld);
      formData.append('referencia', this.dataReferencia != "" ? this.dataReferencia : this.referencia,)
      formData.append('unidad_de_medida', this.dataUnidadMedida != "" ? this.dataUnidadMedida : this.unidadMedida,)
      formData.append('tipo_materia_prima', this.dataMateriaPrima != "" ? this.dataMateriaPrima : this.materiaPrima)
      formData.append('costo_unitario', this.dataCostoUnitario != 0 ? parseFloat(this.dataCostoUnitario) : parseFloat(this.costoUnitario))
      formData.append('tasa_de_cambio', this.dataTasaCambio != 0 ? parseFloat(this.dataTasaCambio) : parseFloat(this.tasaCambio))
      formData.append('cantidad', 1)
      formData.append('costo_total', this.dataCostoUnitario != 0 ? parseFloat(this.dataCostoUnitario) : parseFloat(this.costoUnitario))
      axios
        .post(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}componente-update/${this.componentId}`,
          formData, config)
        .then(() => {
          setTimeout(() => {
            this.buttonText = 'Listo!'
            this.buttonBg = 'bg-costeaDarkGreen'
          }, 100)
          setTimeout(() => {
            this.toggleModal()
          }, 1000)
          setTimeout(() => {
            this.buttonText = 'Editar'
            this.buttonBg = 'bg-costeaPrimary'
          }, 3000)
        }
        ).catch(
          (error) => {
            console.log(error)
          }
        );
    },
    getCostoHoras(costoArea, horasMes, trabajadores) {
      let total = costoArea / (horasMes * trabajadores)
      total = total.toFixed(2)
      return total
    },
    modalActive() {
      this.modalAct = true
      this.modalAct == true ? this.modalAct = false : this.modalAct = true
      return this.modalAct
    },
    toggleModal() {
      this.$emit('closeModalEdit', this.modalActive())
      this.$emit('reloadData', true)
    },
    onProcess() {
      this.buttonText = 'Editando...'
    },
    onSelectedImage(event) {
      this.picture = event.target.files[0]
      console.log(this.picture)
    },
    pickFile() {
      let input = this.$refs.myFiles
      let file = input.files
      if (file && file[0]) {
        let reader = new FileReader
        reader.onload = e => {
          this.previewImage = e.target.result
        }
        reader.readAsDataURL(file[0])
      }
    },
  },
}
</script>

<style scoped>
.addmodal {
  background: rgba(0, 0, 0, 0.6);
}
</style>